import React from 'react';

import {getLocalizedStrings} from '@/services/localization/localizationService';

import HomePageForYouContainer from './HomePageForYouContainer/HomePageForYouContainer';

const HomePageTradeInItem = (props) => {
    const {banner, promotedBadgeType} = props;
    const {
        titleKey,
        descriptionKey,
        promotionKey,
        imageMedia,
        videoPath,
        isGradient,
        isDarkBannerText,
        amplitudeTrackingValue,
        action,
        actionAriaLabelKey,
    } = banner;
    const localizedStrings = getLocalizedStrings();

    return (
        <HomePageForYouContainer
            externalLink={action}
            imageMedia={imageMedia}
            videoPath={videoPath}
            isDarkText={isDarkBannerText}
            promotedBadgeType={promotedBadgeType}
            badgeText={localizedStrings[promotionKey]}
            titleText={localizedStrings[titleKey]}
            descriptionText={localizedStrings[descriptionKey]}
            amplitudeTrackingValue={amplitudeTrackingValue}
            linearGradient={isGradient}
            ariaLabelKey={actionAriaLabelKey}
        />
    );
};

export default HomePageTradeInItem;
